import { Box, Button, Flex, Typography } from "@jewlr/storybook/core"
import styled from "styled-components"

export const Cta = styled(Button).attrs((props) => ({
  variant: "primary",
  width: "100%",
  ...props.theme.loginForm.cta,
  ...props,
}))``

export const FieldContainer = styled(Box).attrs((props) => ({
  ...props.theme.loginForm.fieldContainer,
}))``

export const RememberMeContainer = styled(Flex).attrs((props) => ({
  justifyContent: "space-between",
  textAlign: "left",
  ...props.theme.loginForm.rememberMeContainer,
  ...props,
}))``

export const ForgotPassword = styled(Button).attrs((props) => ({
  underline: true,
  variant: "text",
  ...props.theme.loginForm.forgotPassword,
}))``

export const Footnote = styled(Typography).attrs((props) => ({
  ...props.theme.loginForm.footnote,
  ...props,
}))``

export const SubscribeBox = styled(Box).attrs((props) => ({
  textAlign: "left",
  ...props.theme.loginForm.subscribeBox,
  ...props,
}))``

export const AuthenticateContent = styled(Flex)`
  align-items: center;
  height: 100%;
  text-align: center;
  ${(props) => props.theme.mediaQueries.tablet`
    text-align: left;
    width: 640px;
  `}
  ${(props) => props.theme.mediaQueries.desktop`
    width: 855px;
  `}
`

export const AuthenticateModalTitle = styled(Typography).attrs({
  as: "h1",
  mb: 2,
})`
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
`

export const Separator = styled(Flex)`
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: -0.03em;
  line-height: 18px;
  text-align: center;

  &:before {
    margin-right: 32px;
  }

  &:after {
    margin-left: 32px;
  }

  &:before,
  &:after {
    border-bottom: 1px solid ${(props) => props.theme.colors.grey[65]};
    content: "";
    flex: 1;
  }
`

export const LogoContainer = styled(Flex)`
  gap: 18px;
  justify-content: center;
  margin-bottom: 16px;
`

export const LogoButton = styled(Button).attrs({
  variant: "text",
})`
  height: 30px;
  width: 30px;
`

export const HaveAccount = styled(Typography).attrs((props) => ({
  ...props.theme.loginForm.haveAccount,
}))``
